<template>
  <Teleport to="body">
    <Transition name="fade-mask">
      <div
        v-if="modelValue"
        class="custom-mask-container"
        v-bind="$attrs"
        :style="maskStyle"
        @click="handleMaskClick"
        @touchmove.prevent
      >
        <div class="mask-content" @click.stop>
          <slot></slot>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script>
export default {
  inheritAttrs: false
}
</script>

<script setup>
const props = defineProps({
  // 控制显示隐藏 (v-model)
  modelValue: {
    type: Boolean,
    default: false
  },
  // 遮罩颜色，支持外部传入
  color: {
    type: String,
    default: 'rgba(0, 0, 0, 0.5)'
  },
  // 层级，默认给一个极高值
  zIndex: {
    type: Number,
    default: 9999
  },
  // 点击遮罩是否关闭
  closeOnClickOverlay: {
    type: Boolean,
    default: true
  },
  // 是否锁定滚动条
  lockScroll: {
    type: Boolean,
    default: true
  }
})

const emit = defineEmits(['update:modelValue', 'click'])

// 动态样式
const maskStyle = computed(() => ({
  backgroundColor: props.color,
  zIndex: props.zIndex
}))

// 逻辑处理：点击遮罩层
const handleMaskClick = () => {
  emit('click')
  if (props.closeOnClickOverlay) {
    emit('update:modelValue', false)
  }
}

// 滚动穿透处理：主流方案是在显示时给 body 加 overflow: hidden
watch(
  () => props.modelValue,
  (val) => {
    if (props.lockScroll) {
      document.body.style.overflow = val ? 'hidden' : ''
    }
  },
  { immediate: true }
)
</script>

<style lang="scss" scoped>
.custom-mask-container {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100vw;
  height: 100dvh;
  @include flex-center;
  backface-visibility: hidden;
}

.mask-content {
  position: relative;
  z-index: 1;
}

/* 进场和退场动画 */
.fade-mask-enter-active,
.fade-mask-leave-active {
  transition: opacity 0.3s ease;
}

.fade-mask-enter-from,
.fade-mask-leave-to {
  opacity: 0;
}
</style>
